import React from 'react'
import { Link} from 'react-router-dom'

const CustomToggleForHover = React.forwardRef(({ children,variant, onClick }, ref) => (
    <Link
      to="/dashboard/app/news-feed"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={variant}
    >
      {children}
      
    </Link>
));
  export default CustomToggleForHover;